var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62,63H44c-0.6,0-1-0.4-1-1V36c0-0.6,0.4-1,1-1h5v-6h-5c-0.6,0-1-0.4-1-1V18c0-1.7,1.3-3,3-3h5V9h-7.1 c-3.8,0-6.9,3.1-6.9,6.9V28c0,0.6-0.4,1-1,1h-5v6h5c0.6,0,1,0.4,1,1v26c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1h60 c0.6,0,1,0.4,1,1v60C63,62.6,62.6,63,62,63z M45,61h16V3H3v58h32V37h-5c-0.6,0-1-0.4-1-1v-8c0-0.6,0.4-1,1-1h5V15.9 C35,11,39,7,43.9,7H52c0.6,0,1,0.4,1,1v8c0,0.6-0.4,1-1,1h-6c-0.6,0-1,0.4-1,1v9h5c0.6,0,1,0.4,1,1v8c0,0.6-0.4,1-1,1h-5V61z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ig"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "yt"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "snapchat"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "WA"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Pinterrest"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Messenger"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Tiktok"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "VK"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Thumblr"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "OK.ru"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Weibo"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.39d6f6ab.svg";
export { ForwardRef as ReactComponent };